import { OptionsList } from "@babackapp/customer-ui/components/option";
import { RadioGroup } from "@babackapp/customer-ui/components/radio-group";
import type { ResolutionOption } from "@babackapp/return-widget-components/types";
import { BankTransferOption } from "./bank-transfer-option";
import { DiscountOption } from "./discount-option";

type Props = {
  value: ResolutionOption | null;
  onChange: (value: ResolutionOption) => void;
};

export function RefundOptions({ value, onChange }: Props) {
  return (
    <OptionsList>
      <RadioGroup
        value={value ?? ""}
        onValueChange={(v) => onChange(v as ResolutionOption)}
      >
        <DiscountOption />
        <BankTransferOption selected={value === "bank-transfer"} />
      </RadioGroup>
    </OptionsList>
  );
}
